/**
 * Sort items for the inspection cards
 */
export function sortByOptions(I18n) {
  return [
    {
      value: 'newest',
      label: I18n.t('general.newest'),
    },
    {
      value: 'oldest',
      label: I18n.t('general.oldest'),
    },
  ];
}
